/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'ai-summary-label': 'Tee yhteenveto',
  'copy-content-link-label': 'Kopioi linkki',
  'dynamic-cards-search-page.advanced-search.labels.filter.no.text': 'Hae tunnisteita kirjoittamalla',
  'dynamic-cards-search-page.app-filter-sidebar.all': 'Kaikki',
  'dynamic-cards-search-page.app-filter-sidebar.group': 'Suodata haku tuotteen mukaan',
  'dynamic-cards-search-page.atlas.for': 'ajalle',
  'dynamic-cards-search-page.avatar': 'Avatar',
  'dynamic-cards-search-page.calendar-event-search-result.calendar-label': 'Kalenteri',
  'dynamic-cards-search-page.calendar-event-search-result.join-meeting-link': 'Liity tapaamiseen',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link': 'Kokouslinkki',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon': 'Liity tapaamiseen',
  'dynamic-cards-search-page.calendar-event-search-result.past-events-button': 'Aiemmat tapahtumat',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon': 'Toistuva tapahtuma',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-label': 'Toistuva',
  'dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button': 'Tulevat tapahtumat',
  'dynamic-cards-search-page.compass.owner-name': 'Omistaja: {ownerName}',
  'dynamic-cards-search-page.compass.state': '{state}',
  'dynamic-cards-search-page.compass.tier': 'Taso {tier}',
  'dynamic-cards-search-page.confluence.filter.content.placeholder': 'Etsi sisältöä',
  'dynamic-cards-search-page.confluence.filter.content.selected': 'Valittu',
  'dynamic-cards-search-page.confluence.filter.content.unselected': 'Ehdotettu',
  'dynamic-cards-search-page.confluence.filter.contributor.label.selected': 'Valittu',
  'dynamic-cards-search-page.confluence.filter.contributor.label.unselected': 'Ehdotettu',
  'dynamic-cards-search-page.confluence.filter.contributor.placeholder': 'Etsi henkilöitä',
  'dynamic-cards-search-page.confluence.filter.label.selected': 'Valittu',
  'dynamic-cards-search-page.confluence.filter.labels.placeholder': 'Etsi tunnisteita',
  'dynamic-cards-search-page.confluence.filter.space.placeholder': 'Etsi työtiloja',
  'dynamic-cards-search-page.connect_third_party_product_description': 'Yhdistä tilisi, jotta näet puuttuvat tulokset',
  'dynamic-cards-search-page.connect_third_party_product_title': 'Ylläpitäjä lisäsi tuotteen {product}!',
  'dynamic-cards-search-page.connect_third_party_product_title_alternate': '{product} on nyt saatavilla!',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.end': 'Aloituspäivän tulee olla ennen päättymispäivää',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.today': 'Aloituspäivä ei voi olla tulevaisuudessa',
  'dynamic-cards-search-page.date.filter.custom.invalid.to.after.today': 'Päättymispäivä ei voi olla tulevaisuudessa',
  'dynamic-cards-search-page.date.filter.last.month': 'Kuluneet 30 päivää',
  'dynamic-cards-search-page.date.filter.last.week': 'Kuluneet 7 päivää',
  'dynamic-cards-search-page.date.filter.last.year': 'Kulunut vuosi',
  'dynamic-cards-search-page.document-search-result.google-slides-label': 'Slides',
  'dynamic-cards-search-page.document-search-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.document-search-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.document-search-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.dropdown_generate_answer': 'Luo vastaus',
  'dynamic-cards-search-page.dropdown_recent_icon_label': 'Viimeaikainen',
  'dynamic-cards-search-page.error_primary': 'Meillä on vaikeuksia haun kanssa',
  'dynamic-cards-search-page.error_secondary':
    'Kyseessä voi olla vain ohimenevä vika. Kokeile, ratkeaako ongelma <btn>yrittämällä uudelleen</btn>.',
  'dynamic-cards-search-page.externalPeopleLabel': 'Ulkoiset henkilöt #{channelName}',
  'dynamic-cards-search-page.filter.clear.filter.label': 'Tyhjennä suodatin',
  'dynamic-cards-search-page.filter.last.updated.anytime': 'Milloin vain',
  'dynamic-cards-search-page.filter.last.updated.past30Days': 'Kuluneet 30 päivää',
  'dynamic-cards-search-page.filter.last.updated.past7Days': 'Kuluneet 7 päivää',
  'dynamic-cards-search-page.filter.last.updated.pastYear': 'Kulunut vuosi',
  'dynamic-cards-search-page.filter.last.updated.today': 'Tänään',
  'dynamic-cards-search-page.filter.last.updated.yesterday': 'Eilen',
  'dynamic-cards-search-page.filter.type.answer': 'Vastaukset',
  'dynamic-cards-search-page.filter.type.attachment': 'Liitteet',
  'dynamic-cards-search-page.filter.type.blogpost': 'Blogijulkaisut',
  'dynamic-cards-search-page.filter.type.branch': 'Haarat',
  'dynamic-cards-search-page.filter.type.calendar': 'Kalenterit',
  'dynamic-cards-search-page.filter.type.comment': 'Kommentit',
  'dynamic-cards-search-page.filter.type.commit': 'Commitit',
  'dynamic-cards-search-page.filter.type.component': 'Komponentit',
  'dynamic-cards-search-page.filter.type.conversation': 'Keskustelut',
  'dynamic-cards-search-page.filter.type.database': 'Tietokannat',
  'dynamic-cards-search-page.filter.type.design': 'Suunnittelut',
  'dynamic-cards-search-page.filter.type.documents': 'Asiakirjat',
  'dynamic-cards-search-page.filter.type.issue': 'Asiat',
  'dynamic-cards-search-page.filter.type.message': 'Viestit',
  'dynamic-cards-search-page.filter.type.page': 'Sivut',
  'dynamic-cards-search-page.filter.type.placeholder': 'Etsi tyyppi',
  'dynamic-cards-search-page.filter.type.presentation': 'Esitykset',
  'dynamic-cards-search-page.filter.type.pull-request': 'Pull-pyynnöt',
  'dynamic-cards-search-page.filter.type.question': 'Kysymykset',
  'dynamic-cards-search-page.filter.type.repository': 'Säilöt',
  'dynamic-cards-search-page.filter.type.space': 'Työtilat',
  'dynamic-cards-search-page.filter.type.space-calendar': 'Työtilan kalenterit',
  'dynamic-cards-search-page.filter.type.spreadsheet': 'Laskentataulukot',
  'dynamic-cards-search-page.filter.type.video': 'Videot',
  'dynamic-cards-search-page.filter.type.web-page': 'Verkkosivut',
  'dynamic-cards-search-page.filter.type.whiteboard': 'Valkotaulut',
  'dynamic-cards-search-page.filters.dropdown.clear-all': 'Tyhjennä kaikki',
  'dynamic-cards-search-page.filters.dropdown.title': 'Suodatin',
  'dynamic-cards-search-page.filters.names.content': 'Sisältö sijainnissa',
  'dynamic-cards-search-page.filters.names.contributor': 'Osallistuja',
  'dynamic-cards-search-page.filters.names.labels': 'Tunniste',
  'dynamic-cards-search-page.filters.names.titleMatchOnly': 'Sama otsikko',
  'dynamic-cards-search-page.github-branch-result.label': 'Haara',
  'dynamic-cards-search-page.github-commit-result.label': 'Commit',
  'dynamic-cards-search-page.github-pull-request-result.label': 'Pull-pyyntö',
  'dynamic-cards-search-page.jira.filter.project.placeholder': 'Etsi projekteja',
  'dynamic-cards-search-page.landing_primary': 'Aloita suodattimien käyttö dynaamisille korteille',
  'dynamic-cards-search-page.legacy-third-party-result.google-docs-label': 'Docs',
  'dynamic-cards-search-page.legacy-third-party-result.google-sheets-label': 'Sheets',
  'dynamic-cards-search-page.legacy-third-party-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.legacy-third-party-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.legacy-third-party-result.slack-label': 'Slack',
  'dynamic-cards-search-page.no_results_primary': 'Emme löytäneet yhtään hakuasi vastaavaa tulosta',
  'dynamic-cards-search-page.no_results_secondary_some_filters_applied':
    'Käytössä näyttää olevan joitakin suodattimia. Yritä tyhjentää ne.',
  'dynamic-cards-search-page.nouns.goal': 'Päämäärä',
  'dynamic-cards-search-page.nouns.goals': 'Tavoitteet',
  'dynamic-cards-search-page.nouns.tag': 'Tunniste',
  'dynamic-cards-search-page.nouns.tags': 'Tunnisteet',
  'dynamic-cards-search-page.number_of_results': 'Näytetään {numberOfResults,number}/{totalCount,number} tulosta',
  'dynamic-cards-search-page.oauth-banner.authorization-fail': 'Tuotteen {product} valtuutus epäonnistui.',
  'dynamic-cards-search-page.oauth-banner.authorization-success': '{product} valtuutettu.',
  'dynamic-cards-search-page.oauth-message-connect': 'Yhdistä',
  'dynamic-cards-search-page.products.custom-website': 'Verkkosivu',
  'dynamic-cards-search-page.results-sort.createdDate.selected': 'Lajitteluperuste: luotu (uusin)',
  'dynamic-cards-search-page.results-sort.createdDateDESC': 'Luotu (uusin)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC': 'Päivitetty (uusin)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected': 'Lajitteluperuste: päivitetty (uusin)',
  'dynamic-cards-search-page.results-sort.sort-options.label': 'Vaihda luettelon lajittelua',
  'dynamic-cards-search-page.rovo-onboarding-next': 'Seuraava',
  'dynamic-cards-search-page.rovo-onboarding-step-1-description':
    'Suodata tuotteen mukaan, jotta saat osuvampia hakutuloksia.',
  'dynamic-cards-search-page.rovo-onboarding-step-1-heading': 'Hae kaikista yrityksesi työtiloista',
  'dynamic-cards-search-page.rovo-onboarding-step-1-progress': '1/2',
  'dynamic-cards-search-page.rovo-onboarding-step-2-description':
    'Nämä vaihtoehdot vaihtelevat suodattamasi tuotteen mukaan, jotta saat tarkkoja tuloksia.',
  'dynamic-cards-search-page.rovo-onboarding-step-2-heading': 'Löydä etsimäsi',
  'dynamic-cards-search-page.rovo-onboarding-step-2-progress': '2/2',
  'dynamic-cards-search-page.search-result.attachment-label': 'Liite',
  'dynamic-cards-search-page.search-result.attachments.attached-date.label': 'Liitetty {formattedDate}',
  'dynamic-cards-search-page.search-result.attachments.audio-label': 'Ääni',
  'dynamic-cards-search-page.search-result.attachments.image-label': 'Kuva',
  'dynamic-cards-search-page.search-result.attachments.pdf-label': 'PDF',
  'dynamic-cards-search-page.search-result.last-modified': 'Päivitetty {formattedDate}',
  'dynamic-cards-search-page.search-result.private-channel-label': 'Yksityinen kanava',
  'dynamic-cards-search-page.search-result.remove-recent-search': 'Poista viimeisin haku ‑kuvake',
  'dynamic-cards-search-page.search-result.repository-label': 'Säilö',
  'dynamic-cards-search-page.search-result.thread-title-wth-others':
    '{contributorCount, plural, =0 {Ryhmäviesti, joka lähetettiin myös ulkoisille käyttäjille} =2 {{name1} ja {name2}} =3 {{name1}, {name2} ja {name3}} =4 {{name1}, {name2}, {name3} ja {overflowContributorCount} muu} one {{name1}} other {{name1}, {name2}, {name3} ja {overflowContributorCount} muuta}}',
  'dynamic-cards-search-page.search-result.unknown-channel-in-thread': 'tuntematon-kanava',
  'dynamic-cards-search-page.search_result_type_answer': 'Vastaus',
  'dynamic-cards-search-page.search_result_type_card': 'Kortti',
  'dynamic-cards-search-page.search_result_type_component': 'Komponentti',
  'dynamic-cards-search-page.search_result_type_document': 'Asiakirja',
  'dynamic-cards-search-page.search_result_type_embed': 'Smart Link',
  'dynamic-cards-search-page.search_result_type_folder': 'Kansio',
  'dynamic-cards-search-page.search_result_type_presentation': 'Esitys',
  'dynamic-cards-search-page.search_result_type_pull_request': 'Pull-pyyntö',
  'dynamic-cards-search-page.search_result_type_sharepoint_document': 'SharePoint-asiakirja',
  'dynamic-cards-search-page.search_result_type_space_calendar': 'Työtilan kalenteri',
  'dynamic-cards-search-page.search_result_type_spreadsheet': 'Laskentataulukko',
  'dynamic-cards-search-page.search_result_type_unrecognised': 'Tunnistamaton',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product':
    'Ylläpitäjä on lisännyt tuotteen <strong>{product}</strong>!{br} Yhdistä tilisi, jotta näet puuttuvat tulokset, mukaan lukien asiakirjat, joihin vain sinulla on käyttöoikeus.',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product_alternate':
    '<strong>{product} on nyt saatavilla!</strong>{br} Yhdistä tilisi, jotta näet puuttuvat tulokset, mukaan lukien asiakirjat, joihin vain sinulla on käyttöoikeus.',
  'dynamic-cards-search-page.sidebar-oauth-warning-authorize': 'Valtuuta',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-fail': 'Tuotteen {product} valtuutus epäonnistui.',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-success': '{product} valtuutettu.',
  'dynamic-cards-search-page.tab-filter.all-filter-visual-label': 'Suodata kaikkien sovellusten mukaan',
  'dynamic-cards-search-page.tab-filter.more-dropdown-label': 'Suodata muiden sovellusten mukaan',
  'dynamic-cards-search-page.townsquare.api.goal-state.archived': 'Arkistoitu',
  'dynamic-cards-search-page.townsquare.api.goal-state.at-risk': 'Vaarassa',
  'dynamic-cards-search-page.townsquare.api.goal-state.cancelled': 'Peruutettu',
  'dynamic-cards-search-page.townsquare.api.goal-state.completed': 'Valmis',
  'dynamic-cards-search-page.townsquare.api.goal-state.off-track': 'Ei suunnitelman mukainen',
  'dynamic-cards-search-page.townsquare.api.goal-state.on-track': 'Suunnitelman mukainen',
  'dynamic-cards-search-page.townsquare.api.goal-state.paused': 'Keskeytetty',
  'dynamic-cards-search-page.townsquare.api.goal-state.pending': 'Vireillä',
  'dynamic-cards-search-page.video-search-result.dropdown-message':
    '{chapterCount, plural, one {{chapterCount,number} luku tässä videossa} other {{chapterCount,number} lukua tässä videossa}}',
  'dynamic-cards-search-page.video-search-result.video-icon-label': 'videokuvake',
  'dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text': 'Videon esikatselukuva',
  'dynamic-cards-search-page.work-item-assignee.assigned': 'on määrätty',
  'dynamic-cards-search-page.work-item-creator.created': 'loi',
  'dynamic-cards-search-page.work-item-status.for': 'ajalle',
  'dynamic-cards-search-page.work-item-ticket.label': 'Tukipyyntö',
  'dynamic-cards-search-page.work-item.label': 'Työtehtävä',
  'initialsAvatar.label': 'Nimikirjaimet sisältävä profiilikuva',
  'personAvatar.label': 'Henkilön profiilikuva',
  'search-page.results.private-result-label': 'Yksityinen',
  'search-page.results.private-result-tooltip': 'Näkyvissä vain sinulle',
  'search-page.results.product-results.third-party.channel-member-count':
    '{memberCount, plural, one {{memberCount,number} jäsen} other {{memberCount,number} jäsentä}}',
  'search-page.results.product-results.third-party.channel-type-label': 'Kanava',
  'search-page.results.product-results.third-party.conversation-search-result.label': 'Kanava',
  'search-page.results.product-results.third-party.conversation-search-result.member-count':
    '{count, plural, one {{count,number} jäsen} other {{count,number} jäsentä}}',
  'search-page.results.product-results.third-party.conversation-search-result.time-since-label':
    'Viimeksi aktiivinen {formattedDate}',
  'search-page.results.product-results.third-party.conversation-search-result.unknown-channel': 'tuntematon-kanava',
  'search-page.results.product-results.third-party.external-people-label': 'Ulkoiset henkilöt',
  'search-page.results.product-results.third-party.external-person-label': 'Ulkoinen henkilö',
  'search-page.results.product-results.third-party.last-active': 'Viimeksi aktiivinen {relativeDate}',
  'search-page.results.product-results.third-party.message-type-label': 'Viesti',
  'search-page.results.product-results.third-party.no-contributors-label': 'Ulkoiset henkilöt kanavassa #{channelName}',
  'search-page.results.product-results.third-party.private-conversation-text': '{users} yksityisessä keskustelussa',
  'search-page.results.product-results.third-party.thread-type-label': 'Viestiketju',
  'search-page.results.product-results.third-party.title-and-channel-name': '{title} kanavalla #{channelName}',
  'search-page.results.product-results.third-party.title-with-remaining-contributors':
    '{remainingContributorsCount, plural, one {{title} ja {remainingContributorsCount} muu} other {{title} ja {remainingContributorsCount} muuta}}',
  'search-page.results.restricted-result-label': 'Rajoitettu',
  'search-page.results.restricted-result-tooltip': 'Näkyvissä vain määritetyille henkilöille',
  'search-page.show-more-breadcrumbs-button-label': 'Näytä lisää navigointipolkuja',
  'search-page.verified-icon-label': 'Vahvistettu',
  'search-page.verified-icon-tooltip-message': 'Omistaja tai ylläpitäjä on vahvistanut tämän sivun.',
  'search-result.result.count': '{count, plural, one {Näytetään {count} tulos} other {Näytetään {count} tulosta}}',
  'search-result.user-mention.external-person': 'Ulkoinen henkilö',
};
